// extracted by mini-css-extract-plugin
export var optionGrid = "_42-7";
export var optionList = "_42-6";
export var questionsBlock = "_42-9";
export var spacer = "_42-5";
export var stepCenteredContent = "_42-3";
export var stepInner = "_42-0";
export var stepInnerFullWidth = "_42-1";
export var stepInnerLockScroll = "_42-2";
export var stepTransitionFrame = "_42-4";
export var welcomeBlock = "_42-8";